import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactionList from './ReactionList';
import './EditHub.css';

const EditHub = () => {
  const navigate = useNavigate();
  const [jumpInput, setJumpInput] = useState('');
  const [jumpError, setJumpError] = useState(false);

  const handleJump = () => {
    const n = jumpInput.trim();
    if (!n) return;
    setJumpError(false);
    navigate(`/edit/reaction/${n}`);
  };

  return (
    <div className="edit-hub-container">
      <div className="edit-hub-actions">
        <button className="edit-hub-card" onClick={() => navigate('/new')}>
          <div className="edit-hub-card-icon">+</div>
          <div>
            <h2>New Reaction</h2>
            <p>Create a new reaction with molecules and metadata</p>
          </div>
        </button>
        <button className="edit-hub-card" onClick={() => navigate('/triage')}>
          <div className="edit-hub-card-icon">⚡</div>
          <div>
            <h2>Triage</h2>
            <p>Bulk-review and assign roles to existing reactions</p>
          </div>
        </button>
        <button className="edit-hub-card" onClick={() => navigate('/edit/reaction-types')}>
          <div className="edit-hub-card-icon">🏷</div>
          <div>
            <h2>Reaction Types</h2>
            <p>Rename and consolidate reaction type labels</p>
          </div>
        </button>
      </div>

      <div className="edit-hub-list">
        <div className="edit-hub-list-header">
          <h2 className="edit-hub-list-title">Edit a Reaction</h2>
          <div className="edit-hub-jump">
            <input
              className={`edit-hub-jump-input${jumpError ? ' edit-hub-jump-error' : ''}`}
              type="number"
              placeholder="Go to #"
              value={jumpInput}
              onChange={e => { setJumpInput(e.target.value); setJumpError(false); }}
              onKeyDown={e => e.key === 'Enter' && handleJump()}
            />
            <button className="edit-hub-jump-btn" onClick={handleJump}>Go</button>
          </div>
        </div>
        <ReactionList linkPrefix="/edit/reaction/" />
      </div>
    </div>
  );
};

export default EditHub;
